export const REFERRAL_PARTNER_EDIT_WITH_ID = (rowId) =>
  `/admin/referral-partners/edit/${rowId}`;
export const DEACTIVATED_USER = `/admin/access/user/deactivated`;
export const VIEW_USER = (userId) => `/admin/access/user/view-user/${userId}`;
export const LASTCONNECTEDSOFTWARE = `/accounting-software`;
export const INVOICE = `/invoice`;
export const CHANGE_PASSWORD = (passId) =>
  `/admin/access/user/change-password/${passId}`;
export const EDIT_USER = (userId) => `/admin/access/user/edit/${userId}`;
export const ROLE = `/admin/access/role`;
export const CREATE_ROLE = `/admin/access/role/create`;
export const ADMIN_ACCESS_USER = `/admin/access/user`;
export const CREATE_USER = `/admin/access/user/create`;
export const BANNER_NOTIFICATIONS = `/admin/banner-notifications`;
export const CREATE_BANNER_NOTIFICATION = `/admin/banner-notifications/create`;
export const PRICING_PLANS = `/admin/pricing-plans`;
export const PRICING_PLAN_WITH_PLAN_TYPE = `/admin/pricing-plans?planType=Variable`;
export const ADMIN_PROMO_CODES = `/admin/promo-codes`;
export const CREATE_PROMO_CODE = `/admin/promo-codes/create`;

export const EDIT_PROMO_CODE = (rowId) => `/admin/promo-codes/edit/${rowId}`;
export const CLIENT_DETAILS = (loginAsId) =>
  `/admin/access/client-details/${loginAsId}`;
export const EDIT_ROLE = (roleId) => `/admin/access/role/edit/${roleId}`;
export const ACCOUNTING_SOFTWARES = `/admin/accounting-softwares`;
export const EDIT_ACCOUNTING_SOFTWARE = (softwareId) =>
  `/admin/accounting-softwares/edit/${softwareId}`;
export const EDIT_BANNER_NOTIFICATION = (notificationId) =>
  `/admin/banner-notifications/edit/${notificationId}`;
export const CLIENT_DETAILS_WITH_FROM = (loginAsId) =>
  `/admin/access/client-details/${loginAsId}?from=customerList`;
export const CLIENT_DTLS_FROM_DIRECTOR_CORPORATE = (id) =>
  `/admin/access/client-details/${id}?from=directorshipAddCorporate`;
export const EDIT_EMAIL_TEMPLATE = (id) => `/admin/edit-email-template/${id}`;
export const CREATE_PRICING_PLAN = `/admin/pricing-plans/create-plan`;
export const CREATE_PRICING_PLAN_GROUP = `/admin/pricing-plans/create-plan-group`;
export const EDIT_PRICING_PLAN = (planId) =>
  `/admin/pricing-plans/edit-plan/${planId}`;
export const EDIT_PRICING_PLAN_GROUP = (groupId) =>
  `/admin/pricing-plans/edit-plan-group/${groupId}`;
export const CREATE_RISK_BASED_PLAN = (planId) =>
  `/admin/pricing-plans/create-riskbased-plan/${planId}`;
export const REFERRAL_PARTNER_DUPLICATE_WITH_ID = (id) =>
  `/admin/referral-partners/duplicate/${id}`;
export const SALES_LEADS = `/admin/sales-leads`;
export const SALES_LEAD_EDIT = (quoteId) =>
  `/admin/sales-leads/edit/${quoteId}`;
export const EDIT_SMS_TEMPLATE = (id) => `/admin/sms-template/edit/${id}`;
export const DELETED_USER = `/admin/access/user/deleted`;
export const INVOICE_DETAILS = (quoteId) =>
  `/dashboard/invoice-details/${quoteId}`;
export const VERIFY_YOUR_IDENTITY = (id) =>
  `/aplyid/verify-your-identity/${id}`;
export const VERIFY_YOUR_IDENTITY_NO_ID = `/aplyid/verify-your-identity/`;
export const SIGNUP_WITH_PROMO_PARAMS = (promoCode, referralUsageHistoryId) =>
  `/sign-up/${promoCode}/${referralUsageHistoryId}`;
export const SIGN_UP = `/sign-up/`;
export const LOGIN = `/login`;
export const NOT_FOUND = `/404`;
export const COMPLETE_ACCOUNT_SETUP = `/complete-account-setup`;
export const DEMO_ACCOUNT_INVOICES = `/demo-account/invoices`;
export const DEMO_ACCOUNT_INVOICE = `/demo-account/invoice`;
export const EMAIL_TEMPLATES = `/admin/email-templates`;
export const PLATFORM_PARTNER_APIS = `/admin/platform-partner-apis`;
export const REFERRAL_PARTNERS = `/admin/referral-partners`;
export const SMS_TEMPLATES = `/admin/sms-templates`;
export const DASHBOARD = `/admin/dashboard`;
export const ACCOUNT = `/account`;
export const FAQS = `/faqs`;
export const STATEMENTS = `/statements`;
export const UPLOAD_DOCUMENTS = `/upload-documents`;
export const MY_ACCOUNT = `/account`;
export const ADMIN_DEMO_ACCOUNT_INVOICES = `/admin/demo-account/invoices`;
export const CREATE_SMS_TEMPLATE = `/admin/sms-template/create`;
export const RESET_PASSWORD = `/password/reset`;
export const FMFB_TO_FR_PATH = `/admin/migration/fmfb-to-fr`;
export const FR_TO_FMFB_PATH = `/admin/migration/fr-to-fmfb`;
export const MIGRATION_STATUS_PATH = `/admin/migration/status`;
export const INVOICE_DATA_REPORT = `/admin/reports/invoice-data`;
export const ALL_INVOICE_BATCH_DATA_REPORT = `/admin/reports/batch-invoice-data`;
export const PAYMENT_UPDATES = `/admin/payment-updates`;
export const CLIENT_DETAILS_PATH = {
  CLIENT_DETAILS: (userAccountId, source = "invoice") =>
    `/admin/access/client-details/${userAccountId}?from=${source}`
};
export const USER_PERMISSION = `/admin/access/permission`;
export const CREATE_USER_PERMISSION = `/admin/access/permission/create`;
export const EDIT_USER_PERMISSION = (id) =>
  `/admin/access/permission/edit/${id}`;
export const FORBIDDEN = `/admin/forbidden`;
export const REDIRECT_EDIT_EMAIL_URL = `/admin/edit-email-template`;
export const REDIRECT_EDIT_SMS_URL = `/admin/sms-template/edit`;
export const REDIRECT_CLIENT_DETAILS_URL = `/admin/access/client-details`;

export const PARTNER_DASHBOARD = `/partner/dashboard`;
export const PARTNER_CLIENTS = `/partner/clients`;
export const PARTNER_COMMISSION = `/partner/commission`;
